import SimpleCrypto from "simple-crypto-js";
const _secretKey = "ypb-cypher";
export const cipher = new SimpleCrypto(_secretKey);

// const encryptedString = cryptr.encrypt('bacon');
// const decryptedString = cryptr.decrypt(encryptedString);